import { Injectable } from '@angular/core';
import { PopularCategory } from '@app/entities/categories/interfaces/popular-category';
import { CategoriesService } from '@app/entities/categories/services/categories.service';
import { SearchRequest } from '@app/entities/search-requests/interfaces/search-request';
import { SerachRequestsService } from '@app/entities/search-requests/services/serach-requests.service';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { MainpageStateModel } from './mainpage-state.model';
import {
  LoadLatestSearchRequests,
  LoadPopularCategories,
  LoadPopularSearchRequests,
  LoadTrendingSearchRequests,
} from './mainpage.actions';

@State<MainpageStateModel>({
  name: 'Mainpage',
})
@Injectable()
export class MainpageState {
  constructor(
    private serachRequestsService: SerachRequestsService,
    private categoriesService: CategoriesService,
  ) {}

  @Action(LoadLatestSearchRequests)
  @ImmutableContext()
  loadLatestSearchRequests({ setState }: StateContext<MainpageStateModel>) {
    return this.serachRequestsService.getLatest().pipe(
      tap((searchRequests: SearchRequest[]) => {
        return setState((state: MainpageStateModel) => {
          state.latestSearchRequests = searchRequests;

          return state;
        });
      }),
    );
  }

  @Action(LoadTrendingSearchRequests)
  @ImmutableContext()
  loadTrendingSearchRequests({ setState }: StateContext<MainpageStateModel>) {
    return this.serachRequestsService.getTrending().pipe(
      tap((searchRequests: string[]) => {
        return setState((state: MainpageStateModel) => {
          state.trendingSearchRequests = searchRequests;

          return state;
        });
      }),
    );
  }

  @Action(LoadPopularCategories)
  @ImmutableContext()
  loadPopularCategories({ setState }: StateContext<MainpageStateModel>) {
    return this.categoriesService.getPopularCategories().pipe(
      tap((categories: PopularCategory[]) => {
        return setState((state: MainpageStateModel) => {
          state.popularCategories = categories;

          return state;
        });
      }),
    );
  }

  @Action(LoadPopularSearchRequests)
  @ImmutableContext()
  loadPopularSearchRequests({ setState }: StateContext<MainpageStateModel>) {
    return this.serachRequestsService.getPopular().pipe(
      tap((searchRequests: string[]) => {
        return setState((state: MainpageStateModel) => {
          state.popularSearchRequests = searchRequests;

          return state;
        });
      }),
    );
  }
}
